import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../api";
import { Footer } from "../App";

export default function AdminAccept() {
  const [params] = useSearchParams();
  const [error, setError] = useState(null); // null = still working
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return; // StrictMode double-invoke guard: accept is one-shot
    calledRef.current = true;
    const token = params.get("token");
    if (!token) { setError("This invitation link is missing its token."); return; }
    api(`/admin-invites/accept?token=${encodeURIComponent(token)}`)
      .then(() => setError(""))
      .catch((e) => setError(e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="frame">
      <header className="top"><div className="brand"><b>Oracle BFF</b></div></header>
      <div className="auth-wrap">
        <div className="auth-card" data-testid="admin-accept-card">
          <div className="eyebrow">Admin invitation</div>
          {error === null ? (
            <p className="sub" data-testid="admin-accept-loading">Accepting your invitation…</p>
          ) : error === "" ? (
            <div className="auth-success" data-testid="admin-accept-success">
              <p className="big">You're in!</p>
              <p className="sub">
                Your admin access is active. I just sent a magic sign-in link to your inbox.
                Admins always sign in via magic link, and sessions last 48 hours.
              </p>
            </div>
          ) : (
            <>
              <h1>That invitation didn't work</h1>
              <p className="sub" data-testid="admin-accept-error">{error}</p>
              <Link to="/optin" className="stamp-btn solid" data-testid="admin-accept-home-link"
                style={{ display: "inline-block", textDecoration: "none" }}>
                Back to Oracle BFF
              </Link>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
